export const fireCustomEvent = (eventType: string, payload: string) => {
  // We have to use the older API because it is supported by IE
  const event = document.createEvent('CustomEvent')
  event.initCustomEvent(eventType, true, true, payload)
  window.dispatchEvent(event)
}
